export { PAGES_REDUCER } from "./reducer";
export { PagesStore } from "./interfaces/store";
export { SetPages } from "./interfaces/actions";
